import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Stack } from '@mui/material';
import { isLabOrderLate, labOrderStatusConfig } from './labOrderStatus';

export default function LabOrderStatusChip({ labOrder }) {
  const config = labOrderStatusConfig[labOrder.status] ?? { label: labOrder.status };

  return (
    <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', gap: 0.5 }}>
      <Chip
        label={config.label}
        color={config.color ?? 'default'}
        variant={config.variant ?? 'outlined'}
        size="small"
        sx={{ fontWeight: 'bold' }}
      />
      {isLabOrderLate(labOrder) && (
        <Chip label="Atrasado" color="error" size="small" sx={{ fontWeight: 'bold' }} />
      )}
    </Stack>
  );
}

LabOrderStatusChip.propTypes = {
  labOrder: PropTypes.shape({
    status: PropTypes.string.isRequired,
    expectedReturnDate: PropTypes.string,
  }).isRequired,
};
